export default [
  {
    path: '/offers',
    name: 'offers',
    component: () => import('@/views/Offers/Index.vue'),
    meta: {
      pageTitle: 'Teklif Yönetimi',
      breadcrumb: [
        {
          text: 'Teklif Yönetimi',
          active: true,
        },
      ],
      resource: 'APP_OFFERS',
      action: 'read',
    },
  },
  {
    path: '/offers/add',
    name: 'OffersAdd',
    component: () => import('@/views/Offers/Add.vue'),
    meta: {
      pageTitle: 'Teklif Oluştur',
      breadcrumb: [
        {
          text: 'Teklif Yönetimi',
          to: '/offers',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_OFFER_ADD',
      action: 'read',
    },
  },
  {
    path: '/offers/view/:id',
    name: 'OffersView',
    component: () => import('@/views/Offers/View.vue'),
    meta: {
      pageTitle: 'Teklif Görüntüle',
      breadcrumb: [
        {
          text: 'Teklif Yönetimi',
          to: '/offers',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'APP_OFFER_VIEW',
      action: 'read',
    },
  },
  {
    path: '/offers/edit/:id',
    name: 'OffersEdit',
    component: () => import('@/views/Offers/Edit.vue'),
    meta: {
      pageTitle: 'Teklif Güncelle',
      breadcrumb: [
        {
          text: 'Teklif Yönetimi',
          to: '/offers',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_OFFER_EDIT',
      action: 'read',
    },
  },
]
